import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionActions from '@mui/material/AccordionActions'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Grid from '@mui/material/Grid'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import type { GebiedLabel } from '@models/GebiedLabel'

import { PropertyRow } from '../../theme/components/PropertyRow'
import { StyledIconButton } from '../../theme/components/StyledIconButton'

export { GebiedLabelCard }

type Props = {
  labels: GebiedLabel[]
  expanded?: boolean
  mayManageLabels?: boolean
  onClickCreateLabel: () => void
  onClickDeleteLabel: (label: GebiedLabel) => void
}

const GebiedLabelCard = ({
  labels,
  expanded = false,
  mayManageLabels = false,
  onClickCreateLabel,
  onClickDeleteLabel,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  const { verantwoordelijke, gebiedscode, gebiedscodeLabel } = labels[0]

  return (
    <Accordion
      onChange={(_, expanded) => setIsExpanded(expanded)}
      expanded={isExpanded}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Fade in={!isExpanded} appear={false} unmountOnExit>
          <Typography>{gebiedscodeLabel}</Typography>
        </Fade>
      </AccordionSummary>

      <AccordionDetails>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12 }}>
            <PropertyRow label="Gebied" value={gebiedscodeLabel} variant="h5" />
          </Grid>

          <Grid size={{ xs: 6, md: 4 }}>
            <PropertyRow label="Verantwoordelijke" value={verantwoordelijke} />
          </Grid>

          <Grid size={{ xs: 6, md: 8 }}>
            <PropertyRow label="Gebiedscode" value={gebiedscode} />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Label</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>

              <TableBody>
                {labels.map((gebiedLabel) => (
                  <TableRow key={gebiedLabel.label} hover>
                    <TableCell>{gebiedLabel.label}</TableCell>

                    <TableCell align="right" padding="none">
                      {mayManageLabels && (
                        <StyledIconButton
                          title={`${gebiedLabel.label} verwijderen`}
                          onClick={() => onClickDeleteLabel(gebiedLabel)}
                          icon={<DeleteOutlineIcon />}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </AccordionDetails>

      {mayManageLabels && (
        <AccordionActions>
          <Button
            variant="text"
            startIcon={<AddIcon />}
            onClick={onClickCreateLabel}
          >
            Label toevoegen
          </Button>
        </AccordionActions>
      )}
    </Accordion>
  )
}
